import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TSkyUiSpinnerColor, TSkyUiSpinnerSize, TSkyUiSpinnerPosition } from '../../interface';

@Component({
  selector: 'sky-ui-spinner',
  template: `
    <div class="root" [style.zIndex]="zIndex" [ngClass]="['-color-' + color, '-size-' + size, '-position-' + position]">
      <div class="spinner"></div>
    </div>
  `,
  styleUrls: ['./spinner.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkyUiSpinnerComponent {
  @Input() color: TSkyUiSpinnerColor = 'primary';
  @Input() size: TSkyUiSpinnerSize = 'm';
  @Input() position?: TSkyUiSpinnerPosition;
  @Input() zIndex?: number;
}
